import * as Yup from 'yup'
import { translate } from '../Translations/translate'

const ChefLanguageSchema = (lang) => Yup.object().shape({
  language: Yup.string().required(),
  level: Yup.string().required(),
})

export default ChefLanguageSchema